import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
  step = 1;
  activeTab: 'covered' | 'compare' = 'covered';
  portalUrl = environment.link;
  private tabSub?: Subscription;

  readonly steps = [
    { id: 1, label: 'One Club' },
    { id: 2, label: 'Your details' },
    { id: 3, label: 'Your cover' },
    { id: 4, label: 'Payment' }
  ];

  constructor(private dataService: DataService) {}

  ngOnInit() {
    this.activeTab = this.dataService.getMembershipTab();
    this.tabSub = this.dataService.membershipTab.subscribe((tab) => {
      this.activeTab = tab;
    });
  }

  ngOnDestroy() {
    this.tabSub?.unsubscribe();
  }

  stepClass(id: number): string {
    if (id < this.step) {
      return 'done';
    }
    if (id === this.step) {
      return 'on';
    }
    return 'off';
  }

  selectTab(tab: 'covered' | 'compare') {
    this.dataService.setMembershipTab(tab);
  }
}
